import React from 'react';
import styled from 'styled-components';

const AdBanner = styled.div.attrs({
  height: props => props.height,
  width: props => props.width,
  margin: props => props.margin
})`
  height: ${props => props.height};
  width: 100%;
  max-width: ${props => props.width};
  margin: ${props => props.margin};
`;

const adBanner = props => {
  const { className, height, width, margin, id, children } = props;

  return (
    <div
      className={`${className} AdBannerWrapper flex justify-center items-center`}
    >
      <AdBanner
        className="AdBanner"
        id={id}
        height={height}
        width={width}
        margin={margin}
      >
        {children ? children : <span className="f7 tc white">Loading...</span>}

        {/* <div
          style={{
            background: 'red',
            width: '100%',
            height: '100%'
          }}
        /> */}
      </AdBanner>
    </div>
  );
};

export default adBanner;
